// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2bdoL","gfeWrapper":"CalendarEvent_gfeWrapper__2tTfi"};